import { procurementServices } from '@services';
import { QUERY_KEYS } from 'constants/queryKeys';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import {
  PROCUREMENT_ORDERS_FIELDS_MAPPER,
  PROCUREMENT_ORDERS_STAGE_ORDER,
} from 'components/procurement/constants';
import { handleProcurementOrderData, handleSuppliersData } from './utils';

const defaultValues = {
  vehicleDetails: {
    skuId: '',
    manufacturer: '',
    model: '',
    edition: '',
    engineDisplacement: '',
    enginePower: '',
    fuelType: '',
    transmission: '',
    emissions: '',
  },
  equipmentDetails: {
    spareTyre: false,
    repairKit: false,
    doorMats: false,
    homeCharger: false,
    fastCharger: false,
  },
  name: '',
  numberOfVehicles: 0,
  totalSkuPrice: 0,
  isLocal: true,
  documents: [],
  comments: [],
};

const useProcurementOrderOperations = (enableFetch = true) => {
  const router = useRouter();
  const procurementOrderId = router.query?.procurementOrderId;

  const suppliersResponse = useQuery(
    QUERY_KEYS.GET_PROCUREMENT_ORDER_SUPPLIERS_KEY,
    () => procurementServices.getProcurementOrderSuppliers(),
    { enabled: !!procurementOrderId && enableFetch }
  );

  const vehiclesResponse = useQuery(
    QUERY_KEYS.GET_PROCUREMENT_ORDER_VEHICLES_KEY,
    () => procurementServices.getWWWVehicles(),
    {
      enabled:
        !!procurementOrderId && enableFetch && suppliersResponse.isFetched,
    }
  );

  const procurementOrderResponse = useQuery(
    [QUERY_KEYS.GET_PROCUREMENT_ORDER_KEY, procurementOrderId],
    () => {
      return procurementServices.getProcurementOrderById(procurementOrderId);
    },
    {
      enabled:
        !!procurementOrderId && enableFetch && suppliersResponse.isFetched,
    }
  );

  const suppliers = handleSuppliersData(suppliersResponse?.data?.data || []);

  const vehicles = vehiclesResponse?.data?.data || [];

  const procurementOrder = handleProcurementOrderData(
    procurementOrderResponse?.data?.data || {}
  );

  const stages = PROCUREMENT_ORDERS_STAGE_ORDER?.reduce((acc, cur) => {
    const stageOption = PROCUREMENT_ORDERS_FIELDS_MAPPER.stage.options.find(
      (option) => option.value === cur
    );

    if (stageOption) {
      acc.push({
        text: stageOption.text,
        value: cur,
      });
    }

    return acc;
  }, []);

  const loading =
    procurementOrderResponse?.isLoading ||
    suppliersResponse?.isLoading ||
    vehiclesResponse?.isLoading;

  return {
    defaultValues,
    loading,
    procurementOrder,
    procurementOrderId,
    suppliers,
    vehicles,
    stages,
    getProcurementOrder: procurementOrderResponse.refetch,
  };
};

export default useProcurementOrderOperations;
